import { oofDtos } from '@vectronic/openApi-customer';

export const orderItemStatusOrdering: Record<oofDtos.OrderItem.StatusEnum, number> = {
  INCOMPLETE: 0,
  FULFILLED: 1,
  SUBMITTED: 2,
  IN_PRODUCTION: 3,
  PACKED: 4,
  SHIPPED: 5,
  CANCELED: 6,
};
